module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-info-sign"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10317bb6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoIcon.vue
// module id = 425
// module chunks = 1